function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 112 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1912,-778)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.137,186.823L478.266,186.823C478.766,191.208 481.294,193.516 485.577,194.12L485.577,199.157C482.975,199.274 480.678,198.413 478.425,196.971C478.392,197.333 478.349,197.595 478.349,197.857C478.344,201.061 478.359,204.265 478.343,207.469C478.316,212.874 474.444,216.822 468.831,217.19C464.345,217.484 459.849,213.577 459.143,208.77C458.299,203.027 463.15,197.665 468.94,197.946C469.254,197.961 469.566,198.024 469.928,198.071L469.928,203.177C469.654,203.177 469.382,203.19 469.112,203.175C466.496,203.035 464.405,204.848 464.311,207.344C464.221,209.724 466.096,211.785 468.431,211.874C471.073,211.974 473.109,210.123 473.123,207.484C473.157,201.076 473.136,194.667 473.137,188.259L473.137,186.823Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/tk.2d1afe6b2be0be07347d9abd9057d4bb.svg";
export { ForwardRef as ReactComponent };